import BaseDropdownPosition from "js/components/base/BaseDropdownPosition.js";

export default {
    extends: BaseDropdownPosition,
    props: {
        id: {
            type: String,
            default: null,
        },
        options: {
            type: Array,
            default: () => {
                return [];
            },
        },
        typable: {
            type: Boolean,
            default: false,
        },
        insertable: {
            type: Boolean,
            default: false,
        },
        newPromptText: {
            type: String,
            default: "Start typing to create a new entry",
        },
        placeholder: {
            type: String,
            default: "",
        },
    },
    computed: {
        filteredOptions() {
            if (!this.typable) {
                return this.options;
            }

            return this.options.filter((el) => {
                return el.name
                    .toLowerCase()
                    .includes(this.text.trim().toLowerCase());
            });
        },
        filteredNewOptions() {
            return this.newOptions.filter((el) => {
                return el.name
                    .toLowerCase()
                    .includes(this.text.trim().toLowerCase());
            });
        },
        isOptionUnique() {
            const indexInOptions = this.options.findIndex((el) => {
                return el.name.toLowerCase() === this.text.trim().toLowerCase();
            });

            const indexInNewOptions = this.newOptions.findIndex((el) => {
                return el.name.toLowerCase() === this.text.trim().toLowerCase();
            });

            return indexInOptions === -1 && indexInNewOptions === -1;
        },
        uppercaseText() {
            return this.text.charAt(0).toUpperCase() + this.text.slice(1);
        },
    },
    methods: {
        onListWrapperClick() {
            if (this.isListOpen && this.$refs.input !== undefined) {
                this.$refs.input.focus();
            }
        },
    },
};
